import React from 'react';

export default () => (
  <div className="modal-disclaimer">
    <p>
      Crash Mapper has no legal bearing and is intended for informational purposes only.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Modal/Disclaimer.js